var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2C18.2091 2 20 3.79086 20 6V6.5C20 7.05228 19.5523 7.5 19 7.5C18.4477 7.5 18 7.05228 18 6.5V6C18 4.89543 17.1046 4 16 4H8C6.89543 4 6 4.89543 6 6V18C6 19.1046 6.89543 20 8 20H16C17.1046 20 18 19.1046 18 18V17.5C18 16.9477 18.4477 16.5 19 16.5C19.5523 16.5 20 16.9477 20 17.5V18C20 20.2091 18.2091 22 16 22H8C5.79086 22 4 20.2091 4 18V6C4 3.79086 5.79086 2 8 2H16Z",
    fill: "#011235"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7136 12.7005C19.8063 12.6062 19.8764 12.498 19.9241 12.3828C19.9727 12.2657 19.9996 12.1375 20 12.003L20 12L20 11.997C19.9992 11.7421 19.9016 11.4874 19.7071 11.2929L16.7071 8.29289C16.3166 7.90237 15.6834 7.90237 15.2929 8.29289C14.9024 8.68342 14.9024 9.31658 15.2929 9.70711L16.5858 11H10C9.44771 11 9 11.4477 9 12C9 12.5523 9.44771 13 10 13H16.5858L15.2929 14.2929C14.9024 14.6834 14.9024 15.3166 15.2929 15.7071C15.6834 16.0976 16.3166 16.0976 16.7071 15.7071L19.7064 12.7078L19.7136 12.7005Z",
    fill: "#011235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.bb0a9b73d2c585fb771afd8ad78e5b82.svg";
export { ForwardRef as ReactComponent };